/*
 追従ヘッダーがある地点から要素を固定
 */
module.exports = function(scene){
    var $triggerElement = $(scene.triggerElement());
    var $postShare = $triggerElement.find('.post-share')

    scene.on('enter', function() {
        $postShare.addClass('fixed');
    });

    scene.on('leave', function() {
        $postShare.removeClass('fixed');
    });
};



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/scene-postShareIn.js
 **/